import axios from "axios";
import * as types from "./types";

export default {
  async fetchOpenshiftInfo({dispatch}) {
    const response = await dispatch('api', {
      method: 'GET',
      url: `/openshift/info`,
      types: [
        types.OPENSHIFT_INFO_REQUEST,
        types.OPENSHIFT_INFO_SUCCESS,
        types.OPENSHIFT_INFO_FAILURE,
      ]
    });

    return response;
  },

  async unauthenticatedApi({commit, rootState}, {method, url, types, data}) {
    commit(types[0], data);
    try {
      const response = await axios({
        method: method || 'GET',
        url: `${rootState.apiRoot}${url}`,
      });

      commit(types[1], {response});
      return response;
    } catch (e) {
      commit(types[2], {exception: e});
      return null;
    }
  },
}
